//import Device from 'react-native-device-detection';
const Device = require('react-native-device-detection');


import { Dimensions } from 'react-native';

let responsiveDimensionValues = {};

function windowWidthCalc() {
	let width;
	if(Device.isTablet){
		if(Dimensions.get('window').height > Dimensions.get('window').width){
			width=Dimensions.get('window').height;
		} else {
			width=Dimensions.get('window').width
		}
	} else {
	  width=Dimensions.get('window').width;
	}
	return width;
}

function windowHeightCalc() {
	let height;
	if(Device.isTablet){
		if(Dimensions.get('window').height > Dimensions.get('window').width){
			height=Dimensions.get('window').width;
		} else {
			height=Dimensions.get('window').height
		}
	} else {
	  height=Dimensions.get('window').height;
	}
	return height;
}

export default responsiveDimensionValues = {
	windowWidth: windowWidthCalc(),
	windowHeight: windowHeightCalc()
}
